import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=cabbb9e2&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=js&"
export * from "./DashboardView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=cabbb9e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabbb9e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cabbb9e2')) {
      api.createRecord('cabbb9e2', component.options)
    } else {
      api.reload('cabbb9e2', component.options)
    }
    module.hot.accept("./DashboardView.vue?vue&type=template&id=cabbb9e2&scoped=true&", function () {
      api.rerender('cabbb9e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DashboardView.vue"
export default component.exports